<template>
  <div>

      <date-filter-component 
      :startDate.sync="defaultValues.startDate"
      :endDate.sync="defaultValues.endDate"
      :numIncSD.sync="defaultValues.numIncSD"
      :numIncED.sync="defaultValues.numIncED"
      ></date-filter-component>
       
      <v-btn
        color="success"
        class="mr-4"
        @click="validate"
      >
        Validate
      </v-btn>       
      {{JSON.stringify(defaultValues)}}
    <v-divider></v-divider>
      
      
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import dateFilterComponent from "../components/date-filter-component"

export default {
  name: "DataTableTest",
  mixins: [uiView],
  components: {dateFilterComponent},
  computed: {
  
  },
  data: () => ({
    defaultValues:
    {
      numIncSD: "-2",
      numIncED: "1",
      startDate: null,
      endDate: null,
    },
  }),
  methods: {
      validate () {
        
      },
  },
};
</script>
<style lang="scss">
.v-text-field, .v-text-field * {
    line-height: 15px;
    padding: 1px 0 1px;
}

.v-input input {
    max-height: 15px;
}

</style>
